import React from 'react';
import { Link } from 'react-router-dom';
import { formatLink } from '../lib/formatLink';

const SmartLink = ({ to, children, className, ...props }) => {
  const formattedHref = formatLink(to);
  const isExternal = formattedHref.startsWith('http') || formattedHref.startsWith('mailto:') || formattedHref.startsWith('tel:');

  if (isExternal) {
    return (
      <a href={formattedHref} className={className} target={formattedHref.startsWith('http') ? "_blank" : undefined} rel={formattedHref.startsWith('http') ? "noopener noreferrer" : undefined} {...props}>
        {children}
      </a>
    );
  }

  return (
    <Link to={formattedHref} className={className} {...props}>
      {children}
    </Link>
  );
};

export default SmartLink;
